import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CloseScrollStrategy } from "@angular/cdk/overlay";
import { environment } from "src/environments/environment";
import {
  BOOL_OPTIONS,
  GENDER_OPTIONS,
  STATUS_OPTIONS,
  COUNTRY_OPTIONS,
  STATE_OPTIONS,
} from "src/app/enums/registration_options";
import { COUNTRIES } from "src/app/enums/countries";
import Swal from "sweetalert2";

@Component({
  selector: "app-reg",
  templateUrl: "./reg.component.html",
  styleUrls: ["./reg.component.scss"],
})
export class RegComponent implements OnInit {

  submitted = false;
  generatedOTP = false;
  isLoading: boolean;
  hide = true;
  isrequired: boolean = false;
  sources = [
    { value: "Social Media", viewValue: "Social Media" },
    { value: "Online Articles", viewValue: "Online Articles" },
    {
      value: "LinkedIn",
      viewValue: "LinkedIn",
    },
    {
      value: "Conference",
      viewValue: "Conference",
    },
    {
      value: "Mailbox",
      viewValue: "Mailbox",
    },
    { value: "Others", viewValue: "Others" },
  ];
  gender = GENDER_OPTIONS;
  status = STATUS_OPTIONS;
  country = COUNTRY_OPTIONS;
  states = STATE_OPTIONS;
  bool = BOOL_OPTIONS;
  countries = COUNTRIES;
  title = "newMat";
  showReminder = false;


  isLinear = true;
  firstFormGroup: FormGroup;
  verifyFormGroup = new FormGroup({
    otp: new FormControl("", Validators.required),
  });

  constructor(
    private _formBuilder: FormBuilder,
    private router: Router,
    private http: HttpClient
  ) {}
  displayStyles = "none";

  ngOnInit(): void {
    this.isLoading = false;
    this.firstFormGroup = this._formBuilder.group({
      name: ["", Validators.required],
      email: ["", Validators.compose([Validators.required, Validators.email])],
      country: ["", Validators.required],
      state: [""],
      city: [""],
      contact: [
        "",
        Validators.compose([Validators.required, Validators.min(10)]),
      ],
      countrycode: ["", Validators.required],
      gender: ["", Validators.required],
      // status: ["", Validators.required],
      password: ["", [Validators.required, Validators.min(3)]],
      source: ["", Validators.required],
      referral: [""],
    });
  }
  get f() {
    return this.firstFormGroup.controls;
  }

  fireReminder() {
    this.showReminder = true;

  }

  ngAfterViewInit() {
    this.fireReminder();
  }
  
  country_reg() {
    // console.log("Select")
    if (this.firstFormGroup.value.country != "bah" || "kuw" || "oman" || "quatar" || "saudi" || "uae" ) {
      this.firstFormGroup.controls["state"].clearValidators();
      this.firstFormGroup.controls["city"].clearValidators();
      this.isrequired = false;
    } else {
      this.firstFormGroup.controls["state"].setValidators([
        Validators.required,
      ]);
      this.firstFormGroup.controls["city"].setValidators([Validators.required]);
      this.isrequired = true;
    }
    this.firstFormGroup.controls["state"].updateValueAndValidity();
    this.firstFormGroup.controls["city"].updateValueAndValidity();
  }

  // country_reg() {
  //   // console.log("Select")
  //   if (this.firstFormGroup.value.country != "ind") {
  //     this.firstFormGroup.controls["state"].clearValidators();
  //     this.firstFormGroup.controls["city"].clearValidators();
  //     this.isrequired = false;
  //   }
  //   this.firstFormGroup.controls["state"].updateValueAndValidity();
  //   this.firstFormGroup.controls["city"].updateValueAndValidity();
  // }

  generateOTP() {
    this.isLoading = true;
    if (this.firstFormGroup.valid) {
      if (
        // this.firstFormGroup.value.country == "ind" ||
        // this.firstFormGroup.value.country == "other" ||
        this.firstFormGroup.value.country == "bah" ||
        this.firstFormGroup.value.country == "kuw" ||
        this.firstFormGroup.value.country == "oman" ||
        this.firstFormGroup.value.country == "quatar" || 
        this.firstFormGroup.value.country == "saudi" ||
        this.firstFormGroup.value.country == "uae"
      ) {
        this.submitted = true;
        var body: any = new FormData();
        body.append("email", this.firstFormGroup.value.email);

        this.displayStyles = "block";
        this.http
          .post<any>(environment.API_URL + "generate-otp/", body)
          .subscribe(
            (data) => {
              setTimeout("", 5000);
              this.displayStyles = "none";
              this.isLoading = false;
              Swal.fire(data.status);
              this.generatedOTP = true;
              // if (
              //   data.status ==
              //   "Please check your email or spam folder for login credentials"
              // ) {
              //   this.router.navigateByUrl("/login");
              // }
            },
            (error) => {
              setTimeout("", 5000); //Error callback
              console.error("error caught in component");
              this.displayStyles = "none";
              this.isLoading = false;
              Swal.fire(
                error?.error?.status ??
                  "An error ocurred please contact bhavesh@ecell.in"
              );
            }
          );
      }
      // else {
      //   Swal.fire("You are more suitable for Eureka! GCC");
      //   this.isLoading = false;
      //   window.location.replace("https://ecell.in/eurekagcc");
      // }
    } else {
      this.isLoading = false;
      // Swal.fire("Fill all the required details correctly");
      Swal.fire("Reg form error GCC Test");

    }
  }

  submit() {
    this.isLoading = true;
    if (this.firstFormGroup.valid && this.verifyFormGroup.valid) {
      if (
        // this.firstFormGroup.value.country == "ind" ||
        // this.firstFormGroup.value.country == "other" ||
        this.firstFormGroup.value.country == "bah" ||
        this.firstFormGroup.value.country == "kuw" ||
        this.firstFormGroup.value.country == "oman" ||
        this.firstFormGroup.value.country == "quatar" || 
        this.firstFormGroup.value.country == "saudi" ||
        this.firstFormGroup.value.country == "uae"
      ) {
        this.submitted = true;
        var body: any = new FormData();
        body.append("name", this.firstFormGroup.value.name);
        body.append("email", this.firstFormGroup.value.email);
        body.append("country", this.firstFormGroup.value.country);
        body.append("state", this.firstFormGroup.value.state);
        body.append("city", this.firstFormGroup.value.city);
        body.append("contact", this.firstFormGroup.value.contact);
        body.append("ccode", this.firstFormGroup.value.countrycode);
        body.append("gender", this.firstFormGroup.value.gender);
        // body.append("profStat", this.firstFormGroup.value.status);
        body.append("password", this.firstFormGroup.value.password);
        body.append("ref", this.firstFormGroup.value.source);
        body.append("refId", this.firstFormGroup.value.referral);
        body.append("otp", this.verifyFormGroup.value.otp);

        this.displayStyles = "block";
        this.http.post<any>(environment.API_URL + "reg/", body).subscribe(
          (data) => {
            setTimeout("", 5000);
            this.displayStyles = "none";
            this.isLoading = false;
            // Swal.fire(data.status);
            if (
              data.status ==
              "Please check your email or spam folder for login credentials"
            ) {
              //   this.router.navigateByUrl("/login");
              this.login(
                this.firstFormGroup.value.email,
                this.firstFormGroup.value.password
              );
            }
          },
          (error) => {
            setTimeout("", 5000); //Error callback
            console.error("error caught in component");
            this.displayStyles = "none";
            this.isLoading = false;
            Swal.fire("An error ocurred please contact bhavesh@ecell.in");
          }
        );
      } 
      // else {
      //   Swal.fire("You are more suitable for Eureka! GCC");
      //   this.isLoading = false;
      //   window.location.replace("https://ecell.in/eurekagcc");
      // }
    } else {
      this.isLoading = false;
      // Swal.fire("Fill all the required details correctly");
      Swal.fire("Test Error GCC reg");

    }
  }

  login(username: string, password: string) {
    this.http
      .post<any>(environment.API_URL + "api-custom-auth/", {
        username,
        password,
      })
      .subscribe(
        (data) => {
          localStorage.setItem("authToken", data.token);
          localStorage.setItem("allIds", data.all_Ids);
          localStorage.setItem(
            "formFilled",
            data.about_team.team_data.formFilled
          );
          const filled = localStorage.getItem("formFilled");
          localStorage.setItem("name", data.about_team.memb_data.name);
          localStorage.setItem("wDet", data.about_team.memb_data.wDet);
          localStorage.setItem("isReg", data.about_team.team_data.isReg);
          localStorage.setItem("ctry", data.about_team.memb_data.ctry);
          localStorage.setItem("state", data.about_team.memb_data.state);
          localStorage.setItem("city", data.about_team.memb_data.city);
          var values = localStorage.getItem("ctry");
          if (filled == "false") {
            setTimeout("", 5000);
            this.displayStyles = "none";
            this.router.navigate(["/form"]);
          } else if (filled == "true") {
            setTimeout("", 5000);
            this.displayStyles = "none";
            this.router.navigate(["/db"]);
          }
        },
        (error) => {
          //Error callback
          console.error(error);
          // Swal.fire("Wrong Credentials");
          this.displayStyles = "none";
        }
      );
  }
}
